(function () {
  function initForm(form) {
    var endpoint = form.dataset.endpoint || '';
    var status = form.querySelector('[data-story-submit-status]');
    var button = form.querySelector('[data-story-submit-button]');
    var fileInput = form.querySelector('[data-story-submit-file]');
    var preview = form.querySelector('[data-story-submit-preview]');

    if (fileInput && preview) {
      fileInput.addEventListener('change', function () {
        preview.innerHTML = '';
        var file = fileInput.files && fileInput.files[0];
        if (!file) {
          preview.hidden = true;
          return;
        }
        var img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = '';
        preview.appendChild(img);
        preview.hidden = false;
      });
    }

    function showStatus(text, isError) {
      if (!status) return;
      status.textContent = text;
      status.hidden = !text;
      status.classList.toggle('story-submit__status--error', !!isError);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      // Honeypot: if filled, a bot did it. Pretend success, send nothing.
      var honeypot = form.querySelector('input[name="website"]');
      if (honeypot && honeypot.value) {
        form.reset();
        showStatus(form.dataset.successText, false);
        return;
      }

      if (!endpoint) {
        showStatus(form.dataset.closedText, true);
        return;
      }

      if (button) {
        button.disabled = true;
        button.dataset.originalLabel = button.dataset.originalLabel || button.textContent;
        button.textContent = 'Sending…';
      }
      showStatus('', false);

      var formData = new FormData(form);

      fetch(endpoint, { method: 'POST', body: formData })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          form.reset();
          if (preview) {
            preview.innerHTML = '';
            preview.hidden = true;
          }
          showStatus(form.dataset.successText, false);
        })
        .catch(function () {
          showStatus(form.dataset.errorText, true);
        })
        .finally(function () {
          if (button) {
            button.disabled = false;
            button.textContent = button.dataset.originalLabel;
          }
        });
    });
  }

  document.querySelectorAll('[data-story-submit-form]').forEach(initForm);
})();
